(() => {
  if (!document.getElementById('ccm-blog-legacy-cleanup-style')) {
    const cleanupStyle = document.createElement('style');
    cleanupStyle.id = 'ccm-blog-legacy-cleanup-style';
    cleanupStyle.textContent = `
      .ccm-blog-article__content .ccm-blog-legacy-content{max-width:none!important;margin:0!important;font-family:Saira,system-ui,sans-serif!important;color:var(--body)!important;line-height:1.85!important}
      .ccm-blog-article__content .ccm-blog-legacy-content>.eyebrow:first-child,
      .ccm-blog-article__content .ccm-blog-legacy-content>.deck,
      .ccm-blog-article__content .ccm-blog-legacy-hero-duplicate{display:none!important}
      .ccm-blog-article__content .ccm-blog-legacy-content figure{margin:34px 0!important}
      .ccm-blog-article__content .ccm-blog-legacy-content img{display:block!important;width:100%!important;height:auto!important;border-radius:22px!important}
      .ccm-blog-article__content .ccm-blog-legacy-content figcaption{margin-top:9px!important;color:var(--muted)!important;font-size:13px!important;line-height:1.45!important}
      .ccm-blog-article__content .ccm-blog-legacy-content .callout{margin:34px 0!important;padding:24px 26px!important;border:1px solid rgba(212,164,85,.24)!important;border-left:4px solid var(--gold)!important;border-radius:22px!important;background:linear-gradient(135deg,rgba(212,164,85,.1),rgba(255,253,249,.58))!important}
      .ccm-blog-article__content .ccm-blog-legacy-content .source-notes{margin-top:45px!important;padding-top:20px!important;border-top:1px solid var(--line)!important;color:var(--muted)!important;font-size:13px!important;line-height:1.65!important}
    `;
    document.head.appendChild(cleanupStyle);
  }

  document.querySelectorAll('[data-ccm-blog-article]').forEach((article) => {
    if (article.dataset.ccmBlogInitialized === 'true') return;
    article.dataset.ccmBlogInitialized = 'true';

    const content = article.querySelector('.ccm-blog-article__content');
    if (content) {
      content.querySelectorAll(':scope > style').forEach((styleTag) => styleTag.remove());

      const legacyArticle = content.querySelector(':scope > .article');
      if (legacyArticle) {
        legacyArticle.classList.add('ccm-blog-legacy-content');

        const firstChildren = Array.from(legacyArticle.children).slice(0, 4);
        firstChildren.forEach((child) => {
          if (
            child.matches('.eyebrow, .deck') ||
            (child.matches('figure') && !legacyArticle.querySelector('h2, h3'))
          ) {
            child.remove();
          }
        });

        const firstFigure = legacyArticle.querySelector(':scope > figure');
        const firstHeading = legacyArticle.querySelector(':scope > h2, :scope > h3, :scope > section h2, :scope > section h3');
        if (firstFigure && (!firstHeading || firstFigure.compareDocumentPosition(firstHeading) & Node.DOCUMENT_POSITION_FOLLOWING)) {
          firstFigure.classList.add('ccm-blog-legacy-hero-duplicate');
        }
      }
    }

    article.querySelectorAll('[data-ccm-toc-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = article.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
  });
})();
